/**
 * CancerScreeningAPI
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CancerScreeningResultModel } from './cancerScreeningResultModel';

export class GetCancerScreeningsResultModel { 
    cancerScreenings?: Array<CancerScreeningResultModel>;

    constructor(i: any) {
      this.cancerScreenings =
        i.cancerScreenings && i.cancerScreenings.length > 0
          ? i.cancerScreenings.map((cancerScreening: any) => new CancerScreeningResultModel(cancerScreening))
          : [];
    }
}